module.exports = __webpack_public_path__ + "img/17_newYouth_mfx.016d3c4e.png";